export default __webpack_public_path__ + "static/media/nav-logo-white.9263cd16.svg";